import React from "react";
import { Modal } from "react-bootstrap";
import StudentService from "../../../services/student/StudentService";
import UserInformationModalState, { UserInformationModalProps } from "./UserInformationModal.models";
import './UserInformationModal.scss';
import { StudentGeneralInformationView } from "../../../models/views/identity/StudentGeneralInformationView ";
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';

export default class UserInformationModal extends React.PureComponent<UserInformationModalProps, UserInformationModalState> {


    studentService: StudentService;

    constructor(props: any) {
        super(props);
        this.studentService = new StudentService();
        this.state = { haveOtp: false, otpCode: '', personal: {}, statusPage: 0, studentInfo: {} };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        let self = this;
        let splitDate = []
        self.studentService.getStudentInformation().then(function (response) {
            if (response.status === 200) {
                let data: StudentGeneralInformationView = response.data;

                self.setState({ personal: data.personal, studentInfo: {birthday: data.personal.birthday,firstName: data.personal.firstName, lastName: data.personal.lastName, phoneNumber: data.personal.phoneNumber, id: data.personal.id } });

                splitDate = data.personal.birthday.split('/')
                self.setState({
                    birthDateValue : {
                        year:Number(splitDate[0]),
                        month:Number(splitDate[1]),
                        day:Number(splitDate[2])
                    }
                })
            }
        });
    }

    setDate(value:any) {

        if(value !== null && value !== undefined)
        this.setState({
            birthDateValue: {
                day:value.day,
                month:value.month,
                year: value.year,
            }
        })
    }

    changeInfo = (status: boolean) => {
        let self = this;
        let scope = self.state;
        let { birthDateValue } = this.state;

        if (status) {
            self.studentService.changeStudentInfo({
                id: scope.personal.id,
                firstName: scope.studentInfo.firstName,
                lastName: scope.studentInfo.lastName,
                birthday: `${birthDateValue?.year}/${birthDateValue?.month}/${birthDateValue?.day}`
            }).then(function (response) {

                if (response.status === 204) {
                    self.props.AfterHandle();
                    self.props.closeModal();
                }
            });
        }
        else {
            self.studentService.changeStudentPhoneNumber({
                id: scope.personal.id,
                phoneNumber: scope.studentInfo.phoneNumber,
                haveOtp: false
            }).then(function (response) {

                if (response.status === 204)
                    self.setState({ haveOtp: true });
            });
        }
    }

    closeModal = () => {
        this.setState({ haveOtp: true });
        this.props.closeModal();
    }

    changePhoneNumber = () => {
        let self = this;
        let scope = self.state;

        self.studentService.changeStudentPhoneNumber({
            id: scope.personal.id,
            phoneNumber: scope.studentInfo.phoneNumber,
            haveOtp: true,
            otp: scope.otpCode
        }).then(function (response) {

            if (response.status === 204) {
                self.props.AfterHandle();
                self.props.closeModal();
                self.setState({
                    haveOtp: false,
                    otpCode: ''
                });
            }
        });
    }

    render(): React.ReactNode {
        let { studentInfo, statusPage, haveOtp, otpCode, birthDateValue } = this.state;
        let { closeModal, showModal } = this.props;
        let modalBody;
        let modalButton;

        if (statusPage === 0) {
            modalButton = (<button className="btn btn btn-success" onClick={() => this.changeInfo(true)}>تایید</button>);
            modalBody = (<>
                <div className="col-12 notspace">
                    <span>نام</span>
                    <input type="text" value={studentInfo.firstName} onChange={e => this.setState((prevState) => {
                        return { studentInfo: { ...prevState.studentInfo, firstName: e.target.value } }
                    })} className="form-control" placeholder="نام" maxLength={20} />
                </div>
                <div className="col-12 notspace">
                    <span>نام خانوادگی</span>
                    <input type="text" value={studentInfo.lastName} onChange={e => this.setState((prevState) => {
                        return { studentInfo: { ...prevState.studentInfo, lastName: e.target.value } }
                    })} className="form-control" placeholder="نام خانوادگی" maxLength={40} />
                </div>
                <div className="col-12 notspace">
                    <span>تاریخ تولد</span>
                    <DatePicker inputPlaceholder="تاریخ تولد" calendarPopperPosition="bottom"  shouldHighlightWeekends inputClassName="form-control" onChange={value => this.setDate(value)} value={birthDateValue}  colorPrimary ="#fb9905" locale="fa" />
                </div>
            </>)
        }
        else if (statusPage === 1 && !haveOtp) {
            modalButton = (<button className="btn btn btn-primary" onClick={() => this.changeInfo(false)}>ادامه</button>);
            modalBody = (<>
                <div className="col-12 notspace">
                    <span>شماره موبایل</span>
                    <input type="text" value={studentInfo.phoneNumber} onChange={e => this.setState((prevState) => {
                        return { studentInfo: { ...prevState.studentInfo, phoneNumber: e.target.value } }
                    })} className="form-control" placeholder="شماره موبایل" maxLength={11} />
                </div>
            </>);
        }
        else if (statusPage === 1 && haveOtp) {
            modalButton = (<button className="btn btn btn-success" onClick={this.changePhoneNumber}>تایید</button>);
            modalBody = (<>

                <div className="col-12 notspace">
                    <span>کد امنیتی</span>
                    <input type="text" value={otpCode} onChange={e => this.setState({ otpCode: e.target.value })} className="form-control" placeholder="کد امنیتی" maxLength={4} />
                    <span className="editPhoneNumber" onClick={() => this.setState({ haveOtp: false })}>ویرایش شماره همراه</span>
                </div>
            </>);
        }

        let modal = (<>

            <Modal className="user-information-modal" show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        ویرایش اطلاعات فردی
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="modal-body-area">
                    <div className="tab-header">
                        <div className="col-12 " style={{ padding: "0" }}>
                            <div className="tk-inline modal-content-body">
                                <div className={statusPage === 0 ? "col-6 notspace active" : "col-6 notspace"} >
                                    <label className="tk-title" onClick={() => this.setState({ statusPage: 0 })}>اطلاعات فردی</label>
                                </div>
                                <div className={statusPage === 1 ? "col-6 notspace active" : "col-6 notspace"}>
                                    <label className="tk-title" onClick={() => this.setState({ statusPage: 1 })}>شماره موبایل</label>
                                </div>
                            </div>
                        </div>
                    </div >
                    {modalBody}
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    {modalButton}
                    <button className="btn btn btn-primary tk-float-left" onClick={this.closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >

        </>);
        return (<>
            {modal}
        </>)
    }
}





